import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Jumbotron from "react-bootstrap/Jumbotron";
import TermsComponent from "../shared/termsComponent";

const renderIndex = () => {
  return (
    <div>
      <Row>
        <Col xs={6}>
          <Jumbotron style={{ height: "120vh" }}>
            <h3>FAQ</h3>
            <hr></hr>
            <br />
            <ul className="text-left faq">
              <li>
                <h5>Why does my server keep shutting down?</h5>
              </li>
              Servers are put to sleep after an hour of inactivity. Unfortunately not all activity is measurable by our
              monitors, and so we've created the{" "}
              <a href="https://foundryvtt.com/packages/molten-module">molten-module</a> to help notify users before
              their server is set to be shut down. Just install the module and enable it in your world, and you're good
              to go!
              <li>
                <h5>How do I upgrade my account?</h5>
              </li>
              You can upgrade your account in the upper right hand corner underneath the My Account dropdown. You can
              also reach out to <a href="mailto:support@moltenhosting.com">support@moltenhosting.com</a> or the Discord
              and ask to be upgraded.
              <li className="mt-3">
                <h5>Why is my server asking for a password?</h5>
              </li>
              We set a default password when we create your server. This protects it until you're ready to set it up for
              yourself. You can find the default password by viewing your server details.
              <li className="mt-3">
                <h5>Can I change my default password?</h5>
              </li>
              Yes you can! You can set it via the FoundryVTT configuration menu on your server. If you have lost your
              password, please submit a support ticket and we can help you reset it.
              <li className="mt-3">
                <h5>How do I upload/manage/delete my files?</h5>
              </li>
              Head over to your server details page for the connection details. We provide step by step instructions in
              our <a href="https://www.notion.so/Managing-Server-Files-df96be0dcde74775994a86c844ba1a4e">user guide</a>.
              <li className="mt-3">
                <h5>How do I let my players wake my server?</h5>
              </li>
              We provide a "magic URL" in your server details that you can distribute to your players. When they visit
              this link, it will wake the server and take it to the setup page or default world.
              <li className="mt-3">
                <h5>I imported my world via FTP, but I don't see anything or I'm getting a 502 error! What gives?</h5>
              </li>
              The Foundry process needs a restart after you add worlds to the data directory. Click the "Restart
              Foundry" button in your server detail page. That will restart Foundry but leave your server running.
            </ul>
          </Jumbotron>
        </Col>
        <Col xs={6}>
          <Jumbotron style={{ height: "120vh" }}>
            <h3>News</h3>
            <hr></hr>
            <h4 style={{ color: "#FD4A19" }}>December 16, 2023</h4>
            <p className="text-left">
              <br />
              Happy holidays all! As we round out the year I wanted to say thank you to you all for your continued
              support and the trust you place in me to host your games! With the end of the year comes a couple small
              changes and some upcoming features I'm planning to implement!
              <br />
              <br />
              <b style={{ color: "#FD4A19" }}>
                NOTE: User created backups at the ELITE tier will now have a 6 month (180 day) lifespan. You have until
                February 1st, 2024 to export your user-created backups that are older than 180 days.{" "}
              </b>
              <br />
              <br />
              Previously they were never cleaned up but the cost of keeping them around is getting prohibitively
              expensive and is annoying users who have to sift through the giant list of backups. As for what is coming
              next:
              <ol>
                <li>
                  For those of you running HUGE worlds, you've often been faced with the choice of slimming down your
                  world data, or having sluggish games. In the new year I plan to offer larger servers as an addon to
                  your existing subscription. The details are TBD, so keep an eye out for announcements if you think
                  you'll be interested.
                </li>
                <li>
                  LiveKit! It's been running nicely for the folks in ⁠elite-eagles and now its time for me to start
                  setting it up as a product. Similar to above, LiveKit will be available as an addon to your existing
                  subscription should you want to use my LivekIt servers.
                </li>
              </ol>{" "}
              As always, thank you for trusting me to host your games! Happy holidays!{" "}
              <p style={{ color: "#FD4A19" }}> - Mike (VersaceHovercraft)</p>
            </p>
            <br />
          </Jumbotron>
        </Col>
      </Row>
    </div>
  );
};

export default function IndexComponent(props) {
  return props.user.settings.termsAccepted ? (
    renderIndex()
  ) : (
    <TermsComponent user={props.user} getUser={props.getUser} />
  );
}
